import { lazy, Suspense, useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from './Sidebar';
import MobileBottomNav from './MobileBottomNav';
import { useAppStore } from '@/hooks/useStore';
import { cn } from '@/utils/cn';

const TaskDetailPanel = lazy(() => import('@/components/tasks/TaskDetailPanel'));
const GlobalSearch = lazy(() => import('@/components/search/GlobalSearch'));

export default function Layout() {
  const { sidebarOpen, taskModalOpen, searchOpen, openSearch, closeSearch } = useAppStore();

  useEffect(() => {
    const handleSearchShortcut = (event: KeyboardEvent) => {
      if ((event.metaKey || event.ctrlKey) && event.key.toLowerCase() === 'k') {
        event.preventDefault();
        if (searchOpen) closeSearch();
        else openSearch();
      }
    };

    window.addEventListener('keydown', handleSearchShortcut);
    return () => window.removeEventListener('keydown', handleSearchShortcut);
  }, [searchOpen, openSearch, closeSearch]);

  return (
    <div className="app-shell relative flex overflow-hidden">
      <Sidebar />
      <main
        className={cn(
          'min-h-0 min-w-0 flex-1 flex flex-col overflow-hidden',
          // Add bottom padding on mobile to account for bottom nav bar + safe area
          'mobile-shell-content lg:pb-0',
          !sidebarOpen && 'w-full',
        )}
      >
        <Outlet />
      </main>

      {/* Mobile bottom navigation bar */}
      <MobileBottomNav />

      {taskModalOpen && (
        <Suspense fallback={null}>
          <TaskDetailPanel />
        </Suspense>
      )}

      {searchOpen && (
        <Suspense fallback={null}>
          <GlobalSearch />
        </Suspense>
      )}
    </div>
  );
}
